import script from "./Calendar.vue?vue&type=script&setup=true&lang=js"
export * from "./Calendar.vue?vue&type=script&setup=true&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=6294b36e&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6294b36e"]])

export default __exports__